import type { MenuResponse } from '~/types/menu'
import { HOME_TAB_PATH } from '~/constants'

// 권한 검사 없이 항상 접근 허용하는 경로 목록
const BYPASS_PATHS = new Set([
  HOME_TAB_PATH,        // 메인화면(공용 홈) — 전 사용자 랜딩 대상. constants 단일 원천.
  '/base',              // 대시보드 홈
  '/base/error/403',   // 에러 페이지 자체
  '/login',
  '/register',
  '/auth/password-reset',
])

function collectAllowedPaths(menus: MenuResponse[]): Set<string> {
  const paths = new Set<string>()
  for (const menu of menus) {
    if (menu.path) paths.add(menu.path)
    if (menu.children?.length) {
      collectAllowedPaths(menu.children).forEach(p => paths.add(p))
    }
  }
  return paths
}

export default defineNuxtRouteMiddleware(async (to) => {
  if (process.server) return

  // 관리자 영역(/base, /biz) 외 경로는 검사하지 않음
  if (!to.path.startsWith('/base') && !to.path.startsWith('/biz')) return

  // 화이트리스트 경로는 통과
  if (BYPASS_PATHS.has(to.path)) return

  const menuStore = useMenuStore()

  // 메뉴가 아직 로드되지 않았으면 먼저 가져옴
  // (api.ts 인터셉터가 토큰 확보 및 비인증 리다이렉트를 처리함)
  if (!menuStore.loaded) {
    await menuStore.fetchMenus()
  }

  // fetch 후에도 loaded가 false면 비인증 상태 → auth 미들웨어에 위임
  if (!menuStore.loaded) return

  const allowedPaths = collectAllowedPaths(menuStore.menus)

  const isAllowed =
    allowedPaths.has(to.path) ||
    [...allowedPaths].some(p => to.path.startsWith(p + '/'))

  if (!isAllowed) {
    return navigateTo('/base/error/403')
  }
})
